export default __webpack_public_path__ + "static/media/IMG_9775.7d3fba67.JPG";